import { trackEvent } from '@zep/logger/tracking';

import { type ContentShareType } from '@/shared/features/classroom/types';

export interface EnterShareContext {
  trackLocation: string;
  trackPlace?: string;
  contentId: string;
  contentType: ContentShareType;
  isOwner?: boolean;
  classroomId?: string;
}

/**
 * 공유 진입은 이 이벤트 하나로만 센다. 같은 행동을 새 이름으로 또 쌓으면 집계 기준이
 * 갈린다 — 진입점·소유 여부·학급은 prop 으로 얹는다. 가운데 창과 플레이 팝오버가 함께 쓴다.
 */
export const trackEnterShare = (context: EnterShareContext) => {
  trackEvent('enter_share', {
    location: context.trackLocation,
    contentId: context.contentId,
    contentType: context.contentType,
    quizSetId: context.contentId,
    ...(context.trackPlace && { place: context.trackPlace }),
    ...(context.isOwner !== undefined && { is_owner: context.isOwner }),
    ...(context.classroomId && { classroom_id: context.classroomId }),
  });
};
